import { render } from "./VendorsSetup.vue?vue&type=template&id=9cb2b4c8"
import script from "./VendorsSetup.vue?vue&type=script&lang=js"
export * from "./VendorsSetup.vue?vue&type=script&lang=js"

import "./VendorsSetup.vue?vue&type=style&index=0&id=9cb2b4c8&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__